export enum CustomerDataCollectionOrder {
  BeforePayment = 'before_payment',
  AfterPayment = 'after_payment',
}
